// extracted by mini-css-extract-plugin
export default {"downloadVersion":"DownloadVersion_downloadVersion__FKsQU"};